import React, { Component } from "react";

interface IBetHistoryComponent {
    data: {}
}
export const betHistoryComponent: IBetHistoryComponent = {
    data: {
        "COMPONENTS": [
            {
                child: [ ]
            },

        ],
    }


};

export const BetHistoryComponentConfigurationContext = React.createContext(
    {}
);